/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_NotesInputs */

const en_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release notes`)
};

const nl_release_notes = /** @type {(inputs: Release_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release notes`)
};

/**
* | output |
* | --- |
* | "Release notes" |
*
* @param {Release_NotesInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const release_notes = /** @type {((inputs?: Release_NotesInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_NotesInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_release_notes(inputs)
	return en_release_notes(inputs)
});